import { SagaIterator } from 'redux-saga';
import { PapiDeviation } from '@wix/da-papi-types';
import {
  changeOriginalStatus,
  changeOriginalStatusSuccess,
  toggleOriginalStatus,
} from '../../actions/studio/originals';
import { requestPuppy } from '@wix/da-http-client';
import { call, all, put, select, takeLatest } from 'redux-saga/effects';
import { normalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { putEntities } from '@wix/da-shared-react/pkg/redux/entities/actions';
import { deviationSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';
import { OriginalStatusType } from '../../types/originals';
import { getIsOriginalOpen } from '../../selectors/studio/originals';

export function* changeOriginalStatusSaga(
  action: ReturnType<typeof changeOriginalStatus>
): SagaIterator {
  const { deviation, status } = action.payload;
  const isOpen = status === OriginalStatusType.OPEN;
  const response = yield call(
    requestPuppy,
    {
      method: 'post',
      url: '/originals/change_status',
      data: {
        deviationid: deviation.deviationId,
        is_open: isOpen,
      },
    },
    undefined,
    'dashared'
  );

  if (response && response.success) {
    const updatedDeviation = { ...deviation };
    // Update the deviation with new isOpen status
    if (!updatedDeviation.originals) {
      updatedDeviation.originals = {} as any;
    }
    (updatedDeviation.originals as any).isOpen = isOpen;
    const { entities } = normalize(updatedDeviation, deviationSchema);
    yield put(putEntities({ entities }));
    yield put(changeOriginalStatusSuccess(updatedDeviation));
  }
}

export function* toggleOriginalStatusSaga(
  action: ReturnType<typeof toggleOriginalStatus>
): SagaIterator {
  const deviation = action.payload as PapiDeviation;
  const isOpen = yield select(getIsOriginalOpen, deviation.deviationId);
  const status = isOpen ? OriginalStatusType.CLOSED : OriginalStatusType.OPEN;
  yield put(changeOriginalStatus({ deviation, status }));
}

export default function* originalsSaga(): any {
  yield all([
    takeLatest(changeOriginalStatus, changeOriginalStatusSaga),
    takeLatest(toggleOriginalStatus, toggleOriginalStatusSaga),
  ]);
}
